import { useTranslation } from 'react-i18next';

import FormStepWrapper from 'components/form/FormStepWrapper';
import { LocationPicker } from 'components/location/picker/LocationPicker';
import { useCurrentUser } from 'providers/cache/cachedDataHooks';
import { fromUserLocation } from 'services/utils/location/locationPicker.utils';
import { LocationDetailsDto } from 'services/utils/location/locationService.dto';

interface Props {
  defaultLocation?: LocationDetailsDto;
  onCancel?: () => void;
  onConfirm: (location: LocationDetailsDto) => void;
}

export const LocationPickerStep = ({ defaultLocation, onCancel, onConfirm }: Props) => {
  const { t } = useTranslation();
  const { currentUser } = useCurrentUser();
  const resolvedDefault = defaultLocation || fromUserLocation(currentUser?.location);

  return (
    <FormStepWrapper
      header={t('location-picker.header')}
      isValid={true}
      isNextHidden
      disableContentScroll
      onPrevPress={onCancel}>
      <LocationPicker variant='embedded' defaultLocation={resolvedDefault} onConfirm={onConfirm} />
    </FormStepWrapper>
  );
};
